module.exports = __webpack_public_path__ + "static/waffle-2ee7c9f2cb7bf06f8e8b802b4f132b5e.svg";